// component
import Clewlist from "../components/clew-list/ClewList";
import useAxios from "../services/useAxios";
import AuthenticationContext from "../Authentication/AuthenticationContext.ts";

// react
import { useState, useEffect, useContext } from "react";
import Helmet from "react-helmet";
export default function ClewList() {
  const { userInfo } = useContext(AuthenticationContext);

  return (
    <div>
      <Helmet>
        <title>لیست سرنخ ها</title>
      </Helmet>
      {userInfo.userRoll.includes(11) && <Clewlist></Clewlist>}
    </div>
  );
}
